import { render } from "./VideoWallLayoutSelect.vue?vue&type=template&id=27bb277c&ts=true"
import script from "./VideoWallLayoutSelect.vue?vue&type=script&lang=ts"
export * from "./VideoWallLayoutSelect.vue?vue&type=script&lang=ts"

import "./VideoWallLayoutSelect.vue?vue&type=style&index=0&id=27bb277c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__